import React, { useEffect, useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import Dropdown from "rc-dropdown";
import DefaultButton from "../../../styles/materialButtonStyle";
import DatePicker from "../../../elements/datePicker/DatePicker";
import { MillisecondsToTimestamp, TimestampToDate } from "../../../../utils/timestampToDate";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";
import { StyledDatepicker } from "../../../styles/styledDatepicker";
import MappedServicesFilter from "../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";

const CashFlowBalancesHistoryFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("cashFlow");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "currentTab": filterData["currentTab"],
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "operationId": "",
    "service": null,
    "user": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("balancesHistory.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("balancesHistory.filter.filterBy")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="operationId">
                {t("balancesHistory.filter.transactionId")}
              </label>
              <DelayInput
                id="operationId"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "operationId": event.target.value, page: 1 })}
                name="operationId"
                value={filterData["operationId"]}
                type="text"
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("balancesHistory.filter.service")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <MappedServicesFilter
              checkedService={filterData["service"]}
              setCheckedService={data => handleChangeFilterData(data, "service")}

              checkedCurrency={filterData["currency"]}
              setCheckedCurrency={data => handleChangeFilterData(data, "currency")}

              withPaymentSystem={false}
            />
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("balancesHistory.filter.date")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledDatepicker>
              <label htmlFor="dateFrom">
                {t("balancesHistory.filter.dateFrom")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateFrom"
                name="dateFrom"
                className="date-input"
                onChange={dateFrom => setFilterData({
                  ...filterData,
                  "createAt[gte]": MillisecondsToTimestamp(dateFrom),
                  page: 1
                })}
                value={
                  TimestampToDate(filterData["createAt[gte]"] / 1000)
                }
              />
            </StyledDatepicker>
            <StyledDatepicker>
              <label htmlFor="dateTo">
                {t("balancesHistory.filter.dateTo")}
              </label>
              <DatePicker
                format="dd-MM-y"
                id="dateTo"
                name="dateTo"
                className="date-input"
                onChange={dateTo => setFilterData({
                  ...filterData,
                  "createAt[lte]": MillisecondsToTimestamp(dateTo, true),
                  page: 1
                })}
                value={
                  TimestampToDate(filterData["createAt[lte]"] / 1000)
                }
              />
            </StyledDatepicker>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("balancesHistory.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default CashFlowBalancesHistoryFilter;